<template>
  <div class="qmyx-container agent-hf">
    <!-- 身份变更-->
    <div class="status-group">
      <span class="now-label">当前身份:</span>
      <span class="now">{{ nowStatus }}</span>
    </div>
    <div class="choose-text">请选择要变更身份</div>
    <div class="agent-group">
      <div
        class="agent-item"
        v-for="(item, idx) in list"
        :key="idx"
        @click="handleChooseItem(item.value)"
      >
        <input
          type="radio"
          :value="item.value"
          :id="item.id"
          name="agent"
          v-model="radioValue"
        />
        <label class="am-radio-inline" :for="item.id">{{ item.name }}</label>
      </div>
    </div>
    <form class="info-form" id="agentForm">
      <div class="id-wrap active-wrap" v-if="showId">
        <span class="ori-star f-l">*</span>
        <label class="id-text f-l">证件证号:</label>
        <div class="card-num f-l">
          <span id="ID_NUMBER">{{ agentIdNumber }}</span>
        </div>
      </div>
      <div class="phone-wrap active-wrap" v-if="showph">
        <span class="ori-star f-l">*</span>
        <label class="phone-text f-l">手机号码</label>
        <div class="PHONE-num f-l">
          <span id="PHONE_NUMBER">{{ agentPhNumber }}</span>
        </div>
      </div>
    </form>
    <div class="submit-agent" @click="submitChange">提交</div>
    <div class="mask" id="success" v-if="showToast">
      <div class="body">
        <h1 class="title">提示</h1>
        <p class="txt">员工/业主身份需要认证个人信息，是否前往实名认证？</p>

        <div class="btn-group">
          <div class="back tip-btn" @click="goBack">取消</div>
          <div class="next tip-btn text-warning" @click="toCert">确认</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAgent } from "../api";
import { checkSale, updateCategory, checkEmp, checkTeam } from "./api";
import { Toast } from "mint-ui";
export default {
  components: {},
  props: {},
  data() {
    return {
      showToast: false,
      nowStatus: "",
      radioValue: "10",
      agentIdNumber: "",
      agentPhNumber: "",
      agentInfo: {},
      showId: false,
      showph: false,
      list: [
        {
          id: "agent10",
          value: "10",
          name: "全民经纪人"
        },
        {
          id: "agent40",
          value: "40",
          name: "华发员工"
        },
        {
          id: "agent30",
          value: "30",
          name: "华发业主"
        },
        {
          id: "agent50",
          value: "50",
          name: "拓客成员"
        }
      ]
    };
  },
  watch: {
    radioValue: {
      handler(newName, oldName) {
        if (newName == "10") {
          this.showId = false;
          this.showph = false;
        } else if (newName == "30" || newName == "40") {
          this.showId = true;
          this.showph = false;
          // this.checkSale();
        } else if (newName == "50") {
          this.showph = true;
          this.showId = false;
        }
        console.log("radioValue changed", newName);
      }
    }
  },
  computed: {},
  methods: {
    toCert() {
      this.$router.push({ name: "certification" });
    },
    goBack() {
      this.$router.go(-1);
    },
    handleChooseItem(val) {
      this.radioValue = val;
    },
    async getAgent() {
      const data = await getAgent();
      console.log("agent data", data);
      let currentStatus = data.agentLogin.status;
      if (currentStatus == "10") {
        this.nowStatus = "全民经纪人";
      } else if (currentStatus == "30") {
        this.nowStatus = "华发业主";
      } else if (currentStatus == "40") {
        this.nowStatus = "华发员工";
      } else if (currentStatus == "50") {
        this.nowStatus = "拓客团队";
      }
      this.radioValue = currentStatus;
      this.agentIdNumber = data.agentLogin.idNumber;
      this.agentPhNumber = data.agentLogin.agentTel;
      this.agentInfo = data.agentLogin;
    },
    async checkSale() {
      let params = {
        cusName: this.agentInfo.agentName,
        idNumber: this.agentIdNumber
      };
      try {
        await checkSale(params);
        this.submitFn();
      } catch (error) {
        console.log("华发业主 error", JSON.stringify(error));
        this.agentIdNumber
          ? Toast("身份证信息验证未通过")
          : (this.showToast = true);
      }
    },
    async checkEmp() {
      try {
        await checkEmp(this.agentIdNumber);
        this.submitFn();
      } catch (error) {
        console.log("this.agentIdNumber====", this.agentIdNumber);
        this.agentIdNumber
          ? Toast("未匹配到该身份证号码员工")
          : (this.showToast = true);
      }
    },
    async checkTeam() {
      let params = {
        tel: this.agentPhNumber
      };
      const data = await checkTeam(params);
      console.log("checkTeam data", data);
      if (data.body.result.length > 0) {
        this.submitFn();
      } else {
        Toast("未匹配到该手机号码的拓客团队");
      }
    },
    async submitChange() {
      if (this.radioValue == "10") {
        this.submitFn();
      } else if (this.radioValue == "30") {
        this.checkSale();
      } else if (this.radioValue == "40") {
        this.checkEmp();
      } else if (this.radioValue == "50") {
        this.checkTeam();
      }
    },
    async submitFn() {
      let params = {
        status: this.radioValue,
        frozenFlag: "",
        partnerId: "",
        permitFile: ""
      };
      const data = await updateCategory(params);
      if (data == 1) {
        Toast("更改成功");
        setTimeout(() => {
          this.$router.push("/t9_my");
        }, 1000);
      } else {
        Toast("更改失败");
      }
      console.log("submit data", data);
    }
  },
  async activated() {
    await this.getAgent();
    document.title = "身份变更";
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.agent-hf {
  text-align: left;
  padding: 0.36rem 0.48rem;
  .f-l {
    float: left;
  }
  .status-group {
    font-size: 0.32rem;
    color: #222222;
    letter-spacing: 0;
    // font-weight: bold;
    .now-label {
      margin-right: 0.12rem;
    }
  }
  .choose-text {
    font-size: 0.3rem;
    color: #4a4a4a;
    margin-top: 0.36rem;
  }
  .agent-group {
    margin-top: 0.36rem;
  }
  .agent-item {
    line-height: 0.9rem;
    position: relative;
    &:last-child::after {
      display: none;
    }
    &::after {
      position: absolute;
      display: block;
      content: "";
      left: 0.4rem;
      right: 0;
      bottom: 0;
      height: 0.02rem;
      background: #efefef;
    }
  }

  .id-text,
  .phone-text {
    margin-right: 0.12rem;
  }
  .submit-agent {
    background: #f07b24;
    -webkit-border-radius: 0.16rem;
    -moz-border-radius: 0.16rem;
    border-radius: 0.16rem;
    width: 96%;
    height: 0.88rem;
    margin: 0.2rem auto;
    font-size: 0.36rem;
    color: #ffffff;
    text-align: center;
    line-height: 0.88rem;
  }

  .hide2 {
    display: none !important;
  }

  .ori-star {
    color: #f07b24;
  }
  .active-wrap {
    border-bottom: solid 0.02rem #d4d4d4;
    font-size: 0.28rem;
    height: 0.76rem;
    line-height: 0.8rem;
    width: 90%;
    margin: 0.4rem auto;
  }
  .mask {
    z-index: 9999;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    .body {
      width: 5.4rem;
      border-radius: 0.2rem;
      background-color: white;
      .title {
        font-size: 0.34rem;
        color: #030303;
        font-weight: bolder;
        text-align: center;
        padding-top: 0.5rem;
        margin-bottom: 0.2rem;
      }
      .txt {
        font-size: 0.28rem;
        color: #4a4a4a;
        text-align: center;
        margin-bottom: 0.3rem;
        padding: 0.12rem;
        line-height: 0.4rem;
      }
    }
    .btn-group {
      display: -webkit-box;
      display: -webkit-flex;
      display: -moz-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      -moz-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -moz-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      border-top: 0.02rem solid #eee;
    }
    .back:first-child {
      border-right: 0.02rem solid #eee;
    }

    .tip-btn {
      color: #474747;
      -webkit-box-flex: 1;
      -webkit-flex: 1;
      -moz-box-flex: 1;
      -ms-flex: 1;
      flex: 1;
      color: #9b9b9b;
      height: 0.88rem;
      line-height: 0.88rem;
      text-align: center;
    }
    .text-warning {
      color: #f07b24;
    }
  }
  /*
 * radio
 */
  [type="radio"]:checked,
  [type="radio"]:not(:checked) {
    position: absolute;
    left: -199.98rem;
  }

  [type="radio"]:checked + label,
  [type="radio"]:not(:checked) + label {
    position: relative;
    display: inline-block;
    height: 0.4rem;
    padding-left: 0.56rem;
    font-size: 0.32rem;
    line-height: 0.4rem;
    color: #666;
    cursor: pointer;
  }

  [type="radio"]:checked + label:before,
  [type="radio"]:not(:checked) + label:before {
    position: absolute;
    top: 0;
    left: 0;
    width: 0.36rem;
    height: 0.36rem;
    background: #fff;
    border: 0.02rem solid #c9c8c8;
    -webkit-border-radius: 100%;
    -moz-border-radius: 100%;
    border-radius: 100%;
    content: "";
  }

  [type="radio"]:checked + label:before {
    border: none;
  }

  [type="radio"]:checked + label:after,
  [type="radio"]:not(:checked) + label:after {
    position: absolute;
    top: 0rem;
    left: 0rem;
    width: 0.36rem;
    height: 0.36rem;
    background: #44a4f8;
    -webkit-border-radius: 100%;
    -moz-border-radius: 100%;
    border-radius: 100%;
    content: "";
    -webkit-transition: all 0.2s ease;
    -o-transition: all 0.2s ease;
    -moz-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }

  [type="radio"]:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
    -moz-transform: scale(0);
    -ms-transform: scale(0);
    -o-transform: scale(0);
    transform: scale(0);
  }

  [type="radio"]:checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
    background-color: white;
    background-image: url("https://assets.rurushishi.com/yq-rs-make/huafa/img/check.png");
    -webkit-background-size: contain;
    -moz-background-size: contain;
    -o-background-size: contain;
    background-size: contain;
    border: none;
  }
}
</style>
